import { Divider, Text, useTheme } from '@ui-kitten/components';
import { Platform, StyleSheet, View, ViewProps } from 'react-native';
import { ProfileIcons } from '../profileMe/ProfileIcons';
import React from 'react';
import SelectDropdown from 'react-native-select-dropdown';
import { UIHelper as uh } from '../../core';
import { useAppStore } from 'src/core/store';

//props
interface DropdownProps extends ViewProps {
  changeSortedType: (index: number) => void;
}

const Dropdown = (props: DropdownProps) => {
  const data = ['Most recent', 'Alphabetical', 'Oldest'];
  const th = useTheme();
  const theme = useAppStore((state) => state.theme);

  const styleContainer = StyleSheet.create({
    container: {
      width: 200
    },
    dropdownStyle: {
      height: 108,
      width: 102,
      marginLeft: uh.w2DP(9),
      borderRadius: 8,
      borderColor: 'transparent',
      backgroundColor: uh.getHex(th, theme, 'color-basic-100', 'color-basic-900')
    },
    dropdownBtn: {
      width: 100,
      flexDirection: 'row',
      backgroundColor: 'transparent'
      // height: 36
    },
    dropdownBtnTxt: {
      color: th['text-basic-color'],
      fontSize: 14,
      textAlign: 'center'
    },
    CustomizedButtonText: {
      textAlign: 'center'
    },
    icon: {
      width: 20,
      height: 20
    },
    rowStyle: {
      backgroundColor: uh.getHex(th, theme, 'color-basic-100', 'color-basic-900'),
      height: 36,
      borderBottomColor: 'transparent',
      alignItems: 'center'
    },
    rowTxt: {
      height: 36,
      color: th['text-basic-color']
    },
    childContainer: { flex: 1 },
    childText: {
      textAlign: 'center',
      height: Platform.OS == 'web' ? 26 : 16,
      marginTop: Platform.OS == 'web' ? uh.h2DP(14) : uh.h2DP(10),
      color: th['text-basic-color']
    },
    divider: { marginTop: uh.h2DP(9) }
  });

  const renderButton = (selectedItem: string, isOpened: boolean) => (
    <View style={styleContainer.dropdownBtn}>
      <Text style={styleContainer.CustomizedButtonText} category="c2">
        {selectedItem}
      </Text>
      {isOpened ? (
        <ProfileIcons.UpIcon style={styleContainer.icon} fill={th['color-basic-600']} />
      ) : (
        <ProfileIcons.DownIcon style={styleContainer.icon} fill={th['color-basic-600']} />
      )}
    </View>
  );

  const renderItem = (item: string, index: number, isSelected: boolean) => (
    <View style={styleContainer.childContainer}>
      <Text key={`index-${index}`} style={styleContainer.childText} category="c2">
        {item}
      </Text>
      {index < data.length - 1 && <Divider style={styleContainer.divider} />}
    </View>
  );

  return (
    <View>
      <SelectDropdown
        data={data}
        onSelect={(_selectedItem, index) => {
          props.changeSortedType(index);
        }}
        renderButton={renderButton}
        renderItem={renderItem}
        dropdownStyle={styleContainer.dropdownStyle}
        defaultValueByIndex={0}
        // rowStyle={styleContainer.rowStyle}
        // rowTextStyle={styleContainer.rowTxt}
        statusBarTranslucent={false}
        showsVerticalScrollIndicator={false}
      />
    </View>
  );
};

export default Dropdown;
